import { Button, Form, InputNumber, message, Modal, Switch, Table, Typography, Upload, Space } from "antd";
import AppBreadcrumb from "GlobalComponents/AppBreadcrumb";
import { useForm } from "antd/es/form/Form";
import Body from "components/Body";
import Policy from "components/Policy";
import { useEffect, useState } from "react";
import { UploadOutlined } from '@ant-design/icons';
import API from "Util/Axios";
import TextArea from "antd/es/input/TextArea";

const Save = ({ doc, setDoc, onCargado }) => {
    const [form] = useForm()
    const [loading, setLoading] = useState(false);

    const getBase64 = (file) => {
        return new Promise((resolve, reject) => {
            const reader = new FileReader();
            reader.readAsDataURL(file);
            reader.onload = () => resolve(reader.result);
            reader.onerror = (error) => reject(error);
        });
    };

    const onFinish = async () => {
        try {
            const values = await form.validateFields();
            setLoading(true);

            // Extraemos el archivo del objeto de Ant Design
            const file = values.archivo.fileList[0].originFileObj;
            const base64 = await getBase64(file);

            const payload = {
                ...values,
                archivo: base64, // Aquí ya va el base64 para tu Node.js
            };
            console.log(payload)
            await API({
                url: "apk",
                method: "post",
                data: payload
            })
            onCargado?.()
            // Aquí llamarías a tu API: await api.post('/update', payload)

            message.success("Versión subida correctamente");
            setDoc(null);
        } catch (error) {
            console.error("Error:", error);
        } finally {
            setLoading(false);
        }
    };

    return <Modal
        open={doc}
        onCancel={() => setDoc(null)}
        onOk={onFinish}
        confirmLoading={loading}
        okText="Subir y Guardar"
    >

        <Form layout="vertical" form={form}>
            <Form.Item name="versionCode" label="Código de versión" rules={[{ required: true }]}>
                <InputNumber />
            </Form.Item>
            <Form.Item name="versionName" label="Nombre de versión" rules={[{ required: true }]}>
                <InputNumber />
            </Form.Item>
            <Form.Item name="descripcion" label="Descripción" >
                <TextArea />
            </Form.Item>
            <Form.Item valuePropName="checked" name="forceUpdate" label="Forzar actualización">
                <Switch />
            </Form.Item>
            <Form.Item name="archivo" label="APK" rules={[{ required: true, message: 'Por favor selecciona el APK' }]}>
                <Upload
                    beforeUpload={() => false} // Evita la subida automática
                    maxCount={1}
                    accept=".apk"
                >
                    <Button icon={<UploadOutlined />}>Seleccionar APK</Button>
                </Upload>
            </Form.Item>
        </Form>

    </Modal>
}

const Modulo = () => {
    const [docs, setDocs] = useState([])
    const [doc, setDoc] = useState(null)
    const [cargando, setCargando] = useState(false)

    const cargar = async () => {
        try {
            setCargando(true)
            const {data} = await API("apk")
            setDocs(data)
        } catch (err) {

        } finally {
            setCargando(false)
        }
    }
    useEffect(() => {
        cargar()
    }, [])

    return <>
        <Table loading={cargando} dataSource={docs} pagination={false}>
            <Table.Column title="Version" dataIndex={'versionCode'} />
            <Table.Column title="Descripción" dataIndex={'descripcion'}/>
            <Table.Column title="Activa" dataIndex={'activa'} render={(v)=>v?"Sí":"No"}/>
                <Table.Column title="Obligatoria" dataIndex={'forceUpdate'} render={(v)=>v?"Sí":"No"}/>
            <Table.Column title="Acciones" />
        </Table>
        <Save doc={doc} setDoc={setDoc} onCargado={cargar} />
        <Button type="primary" onClick={() => setDoc({})}>Cargar versión</Button>
    </>
}

export default function Apk() {

    return <Body navbar_content={<AppBreadcrumb items={[{ label: "Gestión App Mobile" }]} backTo="/" />}>
        <Typography.Title>App mobile</Typography.Title>
        <br></br>
        <Policy policy="admin:apk" feedback={<>Módulo no permitido</>}>
            <Modulo />
        </Policy>
    </Body>

}